export default {
  tokenKey: 'token',
  pmsParkingDataKey: 'pms-parking-data',
  pmsSessionDataKey: 'pms-session-data',
  pmsUserDataKey: 'pms-user-data',
  pmsUserSettingsKey: 'pms-user-settings',

  eventOnLanguageChanged: 'onLanguageChanged',
  eventOnShowNotification: 'onShowNotification',

  eventOnBookingGraphDone: 'onBookingGraphDone',
  eventOnIncomeGraphDone: 'onIncomeGraphDone',
  eventOnAvailabilityGraphDone: 'onAvailabilityGraphDone',
  eventOnApiSelected: 'onApiSelected',

  eventOnTenantInvitationCreated: 'onTenantInvitationCreated',

  apiSelected: 'apiSelected',
  langSelected: 'langSelected',
  countryConstantsSelected: 'countryConstantsSelected',

  parkingList: 'parkingList',
  parkingSelected: 'parkingSelected',

  eventOnParkingSelected: 'onParkingSelected',
  eventOnScreenSizeChanged: 'onScreenSizeChanged',

  eventOnInitializeWithLanguage: 'onInitializeWithLanguage',
  eventOnParkingAvailabilitiesUpdated: 'onParkingAvailabilitiesUpdated'
};



// WEBPACK FOOTER //
// ./src/store/keys.js